import { AllieChevronBackOutline } from "../../../styling/icons";
import { BackStepButton } from "./ReturnButton.styles";

export const AllieReturnButton = ({ onClick }: { onClick: () => void }) => {
  return (
    <BackStepButton onClick={onClick}>
    <AllieChevronBackOutline
      color="neutral-60"
      style={{ width: '20px', height: '20px' }}
    />
  </BackStepButton>
  );
};
